import React, { Suspense, useEffect } from 'react';
// import ReactDOM from 'react-dom/client';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import 'bootstrap/scss/bootstrap.scss';
import '../assets/sass/app.scss';
import Home from './components/Home';
import NotFoundPage from './components/error/404';
import PrivacyRemovalConfirmation from './components/DPL/PrivacyRemovalConfirmation';

import AOS from 'aos';
import 'aos/dist/aos.css';
import useImageResize from './components/useImageResize';

function App() {
    useEffect(() => {
        AOS.init({
            /* Global settings: */
            // disable: () => window.innerWidth <= 1199,
            startEvent: 'DOMContentLoaded', /* name of the event dispatched on the document, that AOS should initialize on */
            initClassName: 'aos-init', /* class applied after initialization */
            animatedClassName: 'aos-animate', /* class applied on animation */
            useClassNames: false, /* if true, will add content of `data-aos` as classes on scroll */
            disableMutationObserver: false, /* disables automatic mutations' detections (advanced) */
            debounceDelay: 50, /* the delay on debounce used while resizing window (advanced) */
            throttleDelay: 99, /* the delay on throttle used while scrolling the page (advanced) */

            /* Settings that can be overridden on per-element basis, by `data-aos-*` attributes: */
            offset: 120, /* offset (in px) from the original trigger point */
            delay: 100, /* values from 0 to 3000, with step 50ms */
            duration: 1000, /* values from 0 to 3000, with step 50ms */
            easing: 'ease-in-out-quad', /* default easing for AOS animations */
            once: true, /* whether animation should happen only once - while scrolling down */
            mirror: false, /* whether elements should animate out while scrolling past them */
            anchorPlacement: 'top-bottom', /* defines which position of the element regarding to window should trigger the animation */
        });
    }, []);
    useImageResize();
    return (
        <Suspense fallback={null}>

        <HelmetProvider>
            <Router basename=''>
                    <Routes>
                        <Route path='/' element={<Home/>} />
                        <Route path='/:route' element={<Home />} />
                        <Route path='/:route/:slug' element={<Home />} />
                        <Route path="/data-removal-lead/removalConfirmation/:id" element={<PrivacyRemovalConfirmation />} />
                        <Route path='*' element={<NotFoundPage />} />
                    </Routes>
            </Router>
        </HelmetProvider>
        </Suspense>
    );
}
const container = document.getElementById('app');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);